import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "asSupportNotAuth" }
const _hoisted_2 = { class: "asSupportNotAuth_title" }
const _hoisted_3 = { class: "asSupportNotAuth_content" }
const _hoisted_4 = { class: "asSupportNotAuth_text" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "asSupportNotAuth_text -small" }
const _hoisted_7 = { class: "asSupportNotAuth_text" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "asSupportNotAuth_footer" }
const _hoisted_10 = { class: "asSupportNotAuth_text -bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('forTechnicalQuestions')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.$t('pleaseContactEmail')) + " ", 1),
        _createElementVNode("a", {
          href: `mailto:${_ctx.supportEmail}`,
          class: "asSupportNotAuth_link"
        }, _toDisplayString(_ctx.supportEmail), 9, _hoisted_5)
      ]),
      (_ctx.whatsAppNumber)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('partsSpeech.or')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('chattingWhatsApp')), 1),
            _createElementVNode("a", {
              href: _ctx.whatsAppNumber,
              target: "_blank",
              class: "asSupportNotAuth_text"
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "asSupportNotAuth_whatsApp" }, [
                _createElementVNode("div", { class: "asSupportNotAuth_whatsApp_icon" })
              ], -1)
            ]))], 8, _hoisted_8)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('weHelp')) + "! ", 1)
    ])
  ]))
}